/* ============================================================================
   OFFER MILESTONE CALLOUTS — Nintara Baby

   The ACTIVE STEP IS NOW PAINTED SERVER-SIDE by the sticky-cart snippet, from
   cart.item_count. This file no longer decides what shows on first load — it
   only reacts to CHANGES.

   Why: the callouts used to sit display:none until this script had downloaded,
   executed, and completed a /cart.js round-trip. On mobile that's an easy
   1–2 seconds of empty bar. The step index is a pure function of item_count,
   which Liquid already knows — so there was never a reason to ask the network.

   It also no longer runs its own 1s /cart.js poll. sticky-cart-js-file.js is
   already polling; it now emits `sticky-cart:updated` and we listen. That
   halves the cart requests per session. If that script is missing or fails,
   we fall back to our own poll after 2.5s, so this file still works standalone.
   ============================================================================ */

(function () {
  // Deferred script -> the DOM is fully parsed by the time this runs.
  // Picks up EVERY rendered step (sticky-offer-step-1 … -6), so this file can
  // never fall out of sync with how many steps the snippet renders.
  var steps = Array.prototype.slice.call(
    document.querySelectorAll('#sticky-view-cart .sticky-offer-step')
  );
  var STEP_COUNT = steps.length;

  // Nothing to drive (gift-card PDP renders no callouts).
  if (!STEP_COUNT) return;

  /* Seeded from the server-rendered count. The correct step is ALREADY active
     in the markup, so the first cart read reports the same qty, _lastQty
     matches, and update() short-circuits — no DOM write, no flicker.
     If the page came from a stale Shopify cache, the first read differs and we
     correct it on the next tick. Self-healing either way. */
  var CFG = window.__stickyCartConfig || {};
  var _lastQty = typeof CFG.cartItemCount === 'number' ? CFG.cartItemCount : -1;

  // Keep this ladder in sync with the Liquid ladder in the snippet.
  //   qty 0 -> step 1 | qty 1 -> step 2 | qty 2 -> step 3 | qty 3 -> step 4
  //   qty 4 -> step 5 | qty 5+ -> step 6
  // Returns a 0-based index into `steps`.
  function getStepIndexFromQty(qty) {
    if (qty <= 0) return 0;                 // Step 1
    if (qty >= STEP_COUNT - 1) return STEP_COUNT - 1; // Step 6 (qty >= 5)
    return qty;                             // Steps 2–5 (qty 1–4)
  }

  function showStep(index) {
    steps.forEach(function (step, i) {
      if (!step) return;
      step.classList.toggle('is-active', i === index);
    });
  }

  function update(qty) {
    if (typeof qty !== 'number' || qty === _lastQty) return;
    _lastQty = qty;
    showStep(getStepIndexFromQty(qty));
  }

  // ── PRIMARY: piggyback on the poll sticky-cart-js-file.js already runs ──────
  var _gotEvent = false;
  document.addEventListener('sticky-cart:updated', function (e) {
    _gotEvent = true;
    if (e && e.detail) update(e.detail.item_count);
  });

  // ── FALLBACK: if that script never loads or never fires, poll ourselves ─────
  setTimeout(function () {
    if (_gotEvent) return;

    var own = function () {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) { update(cart.item_count); })
        .catch(function () { /* noop */ });
    };

    own();
    setInterval(own, 1000);
  }, 2500);
})();
